// Public: Useful to provide a semantic explanation of weights used to sort
// the results of performing a text-based search.
//
// NOTE: Assuming an ascending-order sorting algorithm.
export default {
  EXACT_MATCH: 0,
  PREFIX_MATCH: 1,
  NORMAL_MATCH: 2,
}
